module.exports = __webpack_public_path__ + "img/2.cc3aa396.jpg";